export const defaultColorList = [
    // Red
    { value: '#FEB2B2' },
    { value: '#F56565' },
    { value: '#C53030' },
    { value: '#822727' },
    // Yellow
    { value: '#FEFCBF' },
    { value: '#ECC94B' },
    { value: '#B7791F' },
    { value: '#744210' },
    // Green
    { value: '#9AE6B4' },
    { value: '#48BB78' },
    { value: '#2F855A' },
    { value: '#22543D' },
    // Blue
    { value: '#90CDF4' },
    { value: '#4299E1' },
    { value: '#2B6CB0' },
    { value: '#2A4365' },
    // Purple
    { value: '#D6BCFA' },
    { value: '#9F7AEA' },
    { value: '#6B46C1' },
    { value: '#44337A' },
    // Gray
    { value: '#CBD5E0' },
    { value: '#718096' },
    { value: '#4A5568' },
    { value: '#333748' },
];
